import axios from "axios";
import React, { useEffect, useReducer, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getTicketTypeInfosByTicketTypeId, getTicketTypeById, getEventInfosByEventId } from "ticketino-api-client";
import { Helmet } from "react-helmet-async";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Loading from "./components/Loading";

import imgIconProgress2 from '../img/icon-progress2.svg';
import imgIconProgressGrey from '../img/icon-progress-grey.svg';
import imgIconProgressTick from '../img/icon-progress-tick.svg';
import imgClose from '../img/icon-close.svg';
import imgExclamation from '../img/exclamation-circle.svg';

import "../css/style.css";
import "../css/shipping-payment.css";

const Step20_Shipping = () => {

    const [orderId] = useState(sessionStorage.getItem("OrderId"));
    const [order, setOrder] = useState({});
    const [countries, setCountries] = useState([]);
    const [tickets, setTickets] = useState([]);
    const [token] = useState(sessionStorage.getItem("token"));
    const [loading, setLoading] = useState(true);
    const [acceptTermsAndConditions, setAcceptTermsAndConditions] = useState(false);
    const [eventDate, setEventDate] = useState("");
    const [entryTime, setEntryTime] = useState("");

    const [showWilhelmLehmbruck, setShowWilhelmLehmbruck] = useState(false);
    const [showLygiaClarkEvent, setShowLygiaClarkEvent] = useState(false);
    const [showLassnigMunchEvent, setShowLassnigMunchEvent] = useState(false);
    const [showVilhelmHammershoiEvent, setShowVilhelmHammershoiEvent] = useState(false);
    const [showCollectionEvent, setShowCollectionEvent] = useState(false);
    const [isMember, setIsMember] = useState(false);

    const [errors, setErrors] = useState({});

    const [user, setUser] = useState({
        salutation: "",
        firstname: "",
        lastname: "",
        company: "",
        street: "",
        place: "",
        city: "",
        country: "176",
        email: "",
        confirmemail: ""
    });

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // fetching resources
    const [resources, setResources] = useState({});

    let { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            break;
        default:
            languageId = 1;
            language = "de";
            break;
    }

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        api.defaults.headers.common['Authorization'] = "Bearer " + token;

        if (orderId) {
            loadOrder(orderId);
            loadCountries();
        }
    }, [orderId]); //gets called when an order is started

    useEffect(() => {
        if (order.tickets && order.tickets.length === 0) {
            navigate(`/${language}/home`);
        }

        setIsMember(tickets.some(ticket => ticket.promotionCode));
    }, [tickets]);

    const formattedDate = (date) => {
        let localLanguageString = 'de-DE';

        if (language === "en") {
            localLanguageString = 'en-US'
        }
        else if (language === "fr") {
            localLanguageString = 'fr-FR'
        }

        let formattedDate = date.toLocaleDateString(localLanguageString, {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        });
        return formattedDate;
    }


    const loadOrder = async (orderId) => {
        try {
            // Order
            const updatedOrder = await getOrderByOrderId(orderId);

            const bookedTickets = updatedOrder.tickets;

            // Booked Tickets
            const updatedTickets = await Promise.all(
                bookedTickets.map(async (ticket) => {

                    const ticketType = await getTicketTypeById(ticket.ticketTypeId);

                    const ticketTypeInfos = await getTicketTypeInfosByTicketTypeId(ticket.ticketTypeId);
                    const ticketTypeInfo = ticketTypeInfos.find(info => info.languageId === languageId) ?? ticketTypeInfos[0];

                    var date = new Date(ticketType.start);
                    setEventDate(formattedDate(date));

                    let isAllInclusiveTicket = ticketTypeInfo.name.toLowerCase().includes("all in one");

                    if (ticket.timeOfEntryFrom && ticket.timeOfEntryTo) {
                        setEntryTime(`${ticket.timeOfEntryFrom.slice(0, -3)} - ${ticket.timeOfEntryTo.slice(0, -3)}`)
                    }

                    let isAllInclusive2 = false;

                    if (ticket.ticketTypeId === 881029 || ticket.ticketTypeId === 881030 || ticket.ticketTypeId === 881031) {
                        isAllInclusive2 = true;
                    }

                    //display all events when it's an "all inclusive" ticket
                    if (isAllInclusiveTicket && !isAllInclusive2) {
                        setShowLassnigMunchEvent(true);
                        setShowCollectionEvent(true);
                    } else if (isAllInclusiveTicket && isAllInclusive2) {
                        setShowLygiaClarkEvent(true);
                        setShowCollectionEvent(true);
                    }
                    else {
                        var eventInfos = await getEventInfosByEventId(ticketType.eventId);
                        const eventInfo = eventInfos.eventInfos.find(info => info.languageId === languageId) ?? eventInfos.eventInfos[0];

                        if (eventInfo) {
                            if (eventInfo.name.toLowerCase().includes("lygia")) {
                                setShowLygiaClarkEvent(true);
                            }
                            else if (eventInfo.name.toLowerCase().includes("lassnig")) {
                                setShowLassnigMunchEvent(true);
                            }
                            else if (eventInfo.name.toLowerCase().includes("vilhelm")) {
                                setShowVilhelmHammershoiEvent(true);
                            }
                            else if (eventInfo.name.toLowerCase().includes("sammlung") || eventInfo.name.toLowerCase().includes("collection")) {
                                setShowCollectionEvent(true);
                            }
                        }
                    }

                    return { ...ticket, ticketType: ticketType, info: ticketTypeInfo, sortOrder: ticketType.sortOrder }
                })
            )

            setOrder(updatedOrder);
            setTickets(updatedTickets);
        }
        catch (error) {
            console.error(error);
        }
    }

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
            if (error.response.status === 404 || error.response.status === 403) {
                navigate(`/${language}/home`);
            }
        }
    }

    async function loadCountries() {
        let countries = await requestCountries();

        if (language)

            if (countries == null) navigate(`/${language}/home`);

        //first add switzerland, germany and austria
        const indexCH = countries.findIndex((c) => c.id === 176);
        const ch = countries[indexCH];
        countries.splice(indexCH, 1);

        var indexDE = countries.findIndex((c) => c.id === 229);
        const de = countries[indexDE];
        countries.splice(indexDE, 1);

        var indexAU = countries.findIndex((c) => c.id === 228);
        const au = countries[indexAU];
        countries.splice(indexAU, 1);

        countries.unshift({ id: "", name: "---------" });
        countries.unshift(au);
        countries.unshift(de);
        countries.unshift(ch);

        setCountries(countries);

        setLoading(false);
    }

    const requestResources = () => {
        axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.log(error.response.data));
    };

    const requestCountries = async () => {
        var response = await axios.get(`${baseUrl}/Countries?languageCode=${language.slice(0, 2)}`);
        return response.data;
    };

    const removeTicket = async (ticketId, ticketName) => {
        if (order != null && order.tickets != null) {
            let ticketTypeIdsToRemove = order.tickets
                .filter(ticket => ticket.id === ticketId)
                .map(ticket => ticket.id);

            let ticketToRemove = order.tickets.find(ticket => ticket.id = ticketId);

            const ticketType = await getTicketTypeById(ticketToRemove.ticketTypeId);

            var eventInfos = await getEventInfosByEventId(ticketType.eventId);
            let eventInfo = eventInfos.eventInfos.find(info => info.languageId === languageId);

            if (!eventInfo || eventInfo === null) {
                eventInfo = eventInfos.eventInfos.find(info => info.languageId === 0);
            }

            if (ticketToRemove && eventInfo) {
                // gtm - remove_from_cart
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'remove_from_cart',
                    'items': [
                        {
                            'item_id': ticketToRemove.ticketTypeId,
                            'item_name': eventInfo?.name,
                            'item_variant': ticketName,
                            'price': ticketToRemove.price,
                            'quantity': 1
                        }
                    ]
                });
            }

            // DELETE request to remove tickets
            await axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                data: { TicketsToRemove: ticketTypeIdsToRemove }
            }).then((res) => {

                loadOrder(order.id)
            })
        }
    };

    const onSubmit = async () => {

        // Validate the form
        const formErrors = validateForm();

        let validAdditionalFields = validateAdditionalFields();

        if (Object.keys(formErrors).length === 0 && validAdditionalFields) {

            // gtm - add_shipping_info
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'add_shipping_info'
            });

            for (let i = 0; i < tickets.length; i++) {
                if (tickets[i].ticketType?.additionalFields && tickets[i].ticketType?.additionalFields.length > 0) {
                    await updateTicketAddress(tickets[i]);
                }
            }

            addAddressToBasket();

        }
    };

    const onInputChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value });
    };

    // Validate the form
    const validateForm = () => {

        const madatoryText = resources?.ThisFieldIsMandatory;

        let formErrors = {};

        if (!/^([a-z A-Zöéàäèü]{1,70})$/.test(user.salutation) && !isMember) formErrors.salutation = madatoryText;
        if (!/^.{1,70}$/.test(user.firstname)) formErrors.firstname = madatoryText;
        if (!/^.{1,70}$/.test(user.lastname)) formErrors.lastname = madatoryText;
        if (!/^.{1,70}$/.test(user.street) && !isMember) formErrors.street = madatoryText;
        if (!/^.{1,70}$/.test(user.place) && !isMember) formErrors.place = madatoryText;
        if (!/^.{1,70}$/.test(user.city) && !isMember) formErrors.city = madatoryText;
        if (!/^([a-z A-Zöéàäèü 0-9 - ]{1,70})$/.test(user.country) && !isMember) formErrors.country = madatoryText;
        if (!/^\S+@\S+\.\S+$/.test(user.email)) formErrors.email = madatoryText;
        if (!/^\S+@\S+\.\S+$/.test(user.confirmemail)) formErrors.confirmemail = madatoryText;

        if (user.email && user.confirmemail && user.email !== user.confirmemail) formErrors.emailmismatch = resources?.EmailMismatch;

        if (!acceptTermsAndConditions) formErrors.acceptTermsAndConditions = resources?.ThisFieldIsMandatoryAgb;

        setErrors(formErrors);

        return formErrors;
    };

    const addAddressToBasket = () => {
        let addressBody = {
            salutation: user.salutation,
            firstname: user.firstname,
            name: user.lastname,
            company: user.company,
            street: user.street,
            postCode: user.place,
            city: user.city,
            countryId: user.country,
            email: user.email,
            languageId: languageId
        };

        if (addressBody.countryId === "") {
            addressBody.countryId = 176;
        }

        axios.put(`${baseUrl}/Order/${orderId}/Address`, addressBody)
            .then((res) => {
                /* redirect to checkout page if its the last interation */
                if (order?.totalPrice === 0) {
                    changePaymentTypeToFree();
                } else {
                    navigate(`/${language}/checkout`);
                }
            })
            .catch((error) => {
            });
    };

    const updateTicketAddress = async (ticket) => {
        let ticketAddress = {
            company: ticket.company,
            firstname: ticket.firstName,
            name: ticket.lastname,
            email: ticket.email,
            salutation: ticket.salutation,
            title: ticket.title,
            function: ticket.function,
            position: ticket.position,
            birthDate: ticket.birthDate,
            additionalCompany: ticket.additionalCompany,
            street: ticket.street,
            postOffice: ticket.postOffice,
            postCode: ticket.postCode,
            city: ticket.city,
            country: ticket.country,
            phone: ticket.phone,
            mobile: ticket.mobile,
            phoneDial: ticket.phoneDial,
            fax: ticket.fax,
            url: ticket.url,
            branch: ticket.branch,
            companyEmail: ticket.companyEmail,
            customvalue1: ticket.customValue1,
            customvalue2: ticket.customValue2,
            customvalue3: ticket.customValue3,
            customvalue4: ticket.customValue4,
            option1: ticket.option1,
            option2: ticket.option2,
            option3: ticket.option3,
            option4: ticket.option4,
            option5: ticket.option5,
            option6: ticket.option6,
            option7: ticket.option7,
            option8: ticket.option8,
            option9: ticket.option9,
            option10: ticket.option10,
            option11: ticket.option11,
            option12: ticket.option12,
            option13: ticket.option13,
            option14: ticket.option14,
            option15: ticket.option15,
            option16: ticket.option16,
            option17: ticket.option17,
            option18: ticket.option18,
            option19: ticket.option19,
            option20: ticket.option20,
            option21: ticket.option21,
            option22: ticket.option22,
            option23: ticket.option23,
            option24: ticket.option24,
        };

        await axios.put(`${baseUrl}/Ticket/${ticket.id}/Address`, ticketAddress)
            .then((res) => {
            })
            .catch((error) => {
            });
    }

    const changePaymentTypeToFree = async () => {
        await axios
            .put(`${baseUrl}/ShopBasket/Order/${orderId}/PaymentType/5`)
            .then(() => {
                confirmShopbasketByOrderId(orderId);
            });
    };

    const confirmShopbasketByOrderId = async (orderId) => {
        try {
            const res = await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/Confirm`);
            navigate(`/${language}/confirmation/${orderId}`);
        } catch (error) {
            console.error(error)
        }
    };

    const getFieldNameByFieldId = (fieldId) => {

        if (fieldId === 10) {
            return "option1";
        }
        else if (fieldId === 11) {
            return "option2";
        }
        else if (fieldId === 12) {
            return "option3";
        }
        else if (fieldId === 13) {
            return "option4";
        }
        else if (fieldId === 14) {
            return "option5";
        }
        else if (fieldId === 15) {
            return "option6";
        }
        else if (fieldId === 16) {
            return "option7";
        }
        else if (fieldId === 17) {
            return "option8";
        }
        else if (fieldId === 18) {
            return "option9";
        }
        else if (fieldId === 19) {
            return "option10";
        }
        return "option11";
    }



    const mapAddtionalFields = (ticket, additionalFields) => {
        let dropdownElements = [];

        for (let i = 0; i < additionalFields.length; i++) {
            let field = additionalFields[i];
            let options = [];

            //atm we are only implementing dropdown
            if (field.fieldControl !== 2) {
                continue;
            }

            for (let j = 0; j < field.options.length; j++) {
                let option = field.options[j];
                options.push(
                    <option key={j} value={option.optionValues[languageId]}>
                        {option.optionValues[languageId]}
                    </option>
                );
            }

            dropdownElements.push(
                <div key={i} className="mb-3">
                    <label>
                        {field.title[languageId] || "Field"}{field.isMandatory ? <span className="red">*</span> : ""}
                    </label>
                    <select className="form-select"
                        required={field.isMandatory}
                        value={ticket[getFieldNameByFieldId(field.saveToField)] || ""}
                        onChange={(e) => handleAdditionalFieldDropdownChange(ticket.id, field.saveToField, e.target.value)}>
                        <option value="">{resources?.PleaseSelect}</option>
                        {options}
                    </select>
                    {ticket.isValid === false &&
                        <>
                            <div className="mt-2 d-flex">
                                <img src={imgExclamation} alt="!" />
                                <span className="red text-16-18 ms-2 mt-1">
                                    {resources?.ThisFieldIsMandatory}
                                </span>
                            </div>
                        </>}
                </div>
            );
        }

        return <div>{dropdownElements}</div>;
    };

    // Handle dropdown change
    const handleAdditionalFieldDropdownChange = (ticketId, saveToField, value) => {

        setTickets((prevTickets) =>
            prevTickets.map((ticket) =>
                ticket.id === ticketId
                    ? {
                        ...ticket, [getFieldNameByFieldId(saveToField)]: value,
                    }
                    : ticket
            )
        );
    };

    const validateAdditionalFields = () => {
        let isValid = true;

        tickets.forEach((ticket) => {
            ticket.ticketType?.additionalFields?.forEach((field) => {

                if (field.isMandatory &&
                    field.fieldControl === 2 &&
                    (ticket[getFieldNameByFieldId(field.saveToField)] === undefined ||
                        ticket[getFieldNameByFieldId(field.saveToField)] == null ||
                        ticket[getFieldNameByFieldId(field.saveToField)] === "")) {
                    ticket.isValid = false;
                    isValid = false;
                }
                else {
                    ticket.isValid = true;
                }
            });
        });
        return isValid;
    };

    const mapTickets = () => {
        let ticketsSorted = [];

        if (tickets && tickets.length > 0) {
            ticketsSorted = [...tickets].sort((a, b) => a.sortOrder - b.sortOrder);
        }

        return (tickets &&
            tickets.length > 0 &&
            ticketsSorted.map((t, index) => (
                (<div key={index} className="row padding-25">
                    <div className="col-6 col-md-7 text-20-24 black-color d-flex flex-column align-items-start">
                        <div className="row">
                            <div className="col">
                                <label>
                                    1 x {t.info?.name}
                                </label>
                            </div>
                        </div>
                        {t.ticketType?.additionalFields && t.ticketType?.additionalFields.length > 0 &&
                            <div className="row margin-top-5">
                                <div className="col">
                                    {mapAddtionalFields(t, t.ticketType.additionalFields)}
                                </div>
                            </div>
                        }
                    </div>
                    <div className="col-1 col-md-2 text-20-24 black-color d-flex justify-content-end align-items-center">
                        <label>
                            {t.currency}
                        </label>
                    </div>
                    <div className="col-1 col-md-2 text-20-24 black-color d-flex justify-content-start align-items-center">
                        <label className="price-label text-end">
                            {t.price.toFixed(2)}
                        </label>
                    </div>
                    <div className="col-4 col-md-1 text-20-24 black-color d-flex justify-content-end align-items-center">
                        <button
                            type="button"
                            className="ticket-remove-btn"
                            aria-label="Close"
                            onClick={() => removeTicket(t.id, t.info?.name)} >
                            <img src={imgClose} alt="X" />
                        </button>
                    </div>

                </div >)
            ))
        );
    };

    return (
        <>
            <Helmet>
                <title>{resources?.HeadShippingTitle}</title>
            </Helmet>

            <div className="d-flex flex-column min-vh-100">
                {loading
                    ? (
                        <Loading
                            alignment="center"
                            color="#d3d3d3"
                            bgColor="transparent"
                            position="fixed"
                            top="50%"
                            left="50%" />
                    ) : (
                        <>
                            <Navbar numberOfTickets={order?.tickets?.length ?? 0} isShoppingCartVisible={true} pagePath="shipping" />
                            <main className="flex-fill">
                                <div className="container page-wrapper">
                                    <div className="progress-container">
                                        {/*<div className="progress-step">*/}
                                        {/*    <div>*/}
                                        {/*        <div className="image cursor-pointer ">*/}
                                        {/*            <img src={imgIconProgressTick} alt="Step 1" onClick={() => navigate(-2)} />*/}
                                        {/*        </div>*/}
                                        {/*        <div className="step-number text-wrap visible-desktop">{resources?.DateAndTime}</div>*/}
                                        {/*    </div>*/}
                                        {/*    <div className="line"></div>*/}
                                        {/*</div>*/}

                                        <div className="progress-step completed">
                                            <div>
                                                <div className="image cursor-pointer ">
                                                    <img src={imgIconProgressTick} alt=" Step 1" onClick={() => navigate(-1)} />
                                                </div>
                                                <div className="step-number text-wrap visible-desktop">{resources?.TicketSelection}</div>
                                            </div>
                                            <div className="line"></div>
                                        </div>

                                        <div className="progress-step active">
                                            <div>
                                                <div className="image">
                                                    <img src={imgIconProgress2} alt="Step 2" />
                                                </div>
                                                <div className="step-number text-wrap visible-desktop">{resources?.SummaryAndContact}</div>
                                            </div>
                                            <div className="line"></div>
                                        </div>

                                        <div className="progress-step">
                                            <div>
                                                <div className="image">
                                                    <img src={imgIconProgressGrey} alt="Step 3" />
                                                </div>
                                                <div className="step-number text-wrap visible-desktop">{resources?.PaymentAndDelivery}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-5">
                                        <div className="col-md-8 padding-0">
                                            <p className="text-50-55 black-color font-500">{resources?.SummaryText}</p>
                                        </div>
                                    </div>
                                    <div className="row margin-top-30 margin-bottom-55">
                                        <div className="col-md-12 div-container-blue padding-left-25 padding-right-25 padding-top-20">
                                            {showLygiaClarkEvent && !showCollectionEvent &&
                                                <>
                                                    <p className="text-30-36-bold black-color ">
                                                        Lygia Clark
                                                    </p>
                                                    <p className="text-20-22-medium black-color mt-3">
                                                        14.11.2025 - 08.03.2026
                                                    </p>
                                                </>}
                                            {showLassnigMunchEvent && !showCollectionEvent &&
                                                <>
                                                    <p className="text-30-36-bold black-color ">
                                                        {resources?.ExhibitionLassnigMunch}
                                                    </p>
                                                    <p className="text-20-22-medium black-color mt-3">
                                                        2.10.2026 – 21.2.2027
                                                    </p>
                                                </>}
                                            {showLassnigMunchEvent && showCollectionEvent &&
                                                <>
                                                    <p className="text-30-36-bold black-color ">
                                                        {resources?.ExhibitionLassnigMunch}
                                                    </p>
                                                    <p className="text-30-36-bold black-color ">
                                                        Vilhelm Hammershøi
                                                    </p>
                                                    <p className="text-20-22-medium black-color mt-3">
                                                        16.8. – 23.08.2026
                                                    </p>
                                                </>}
                                            {showVilhelmHammershoiEvent && !showCollectionEvent &&
                                                <>
                                                    <p className="text-30-36-bold black-color ">
                                                        Vilhelm Hammershøi
                                                    </p>
                                                    <p className="text-20-22-medium black-color mt-3">
                                                        3.7. – 25.10.2026
                                                    </p>
                                                </>}
                                            {showCollectionEvent &&
                                                <>
                                                    <p className="text-30-36-bold black-color mt-2">
                                                        {resources.Collection}
                                                    </p>
                                                    <p className="text-20-22-medium black-color mt-3">
                                                        {resources.SummaryPermanentExhibition}
                                                    </p>
                                                </>}
                                        </div>
                                    </div>

                                    {mapTickets()}

                                    <div className="padding-left-25 padding-right-25" >
                                        <div className="mt-3 grey-line" ></div>
                                    </div>

                                    <div className="row mt-5 mb-5 padding-left-25 padding-right-25">
                                        <div className="col-md-7 col-6 text-20-24 black-color d-flex justify-content-start align-items-center">{resources.Total}:</div>
                                        <div className="col-1 col-md-2 text-20-24 black-color d-flex justify-content-end align-items-center">
                                            <label className="font-600">
                                                CHF
                                            </label>
                                        </div>
                                        <div className="col-1 col-md-1 text-20-24 black-color d-flex justify-content-start align-items-center">
                                            <label className="font-600 price-label text-end"> {order && order.total && order.total !== null ? (
                                                <span>{(order.total).toFixed(2)}</span>
                                            ) : (
                                                <span>0.00</span>
                                            )}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="row mt-5">
                                        <div className="col-12">
                                            <p className="text-50-55 black-color font-500">{resources.Contact}</p>
                                        </div>
                                    </div>
                                    <div className="row mt-3 text-20-24">
                                        <div className="col-md-3 col-4 dark-grey-color d-flex flex-column justify-content-center">
                                            <label>{resources.Salutation}{!isMember && <span className="red">*</span>}</label>
                                        </div>
                                        <div className="col-8 col-md-9">
                                            <select
                                                className="form-control form-select"
                                                aria-label={resources?.ShippingAnrede}
                                                name="salutation"
                                                value={user.salutation}
                                                onChange={(e) => onInputChange(e)}>
                                                <option>{resources?.PleaseSelect}</option>
                                                <option value={resources?._Mr}>{resources?._Mr}</option>
                                                <option value={resources?._Mrs}>{resources?._Mrs}</option>
                                                <option value={resources?._Others}>{resources?._Others}</option>
                                            </select>
                                            {errors.salutation && <>
                                                <div className="mt-2 d-flex">
                                                    <img src={imgExclamation} alt="!" />
                                                    <span className="red text-16-18 ms-2 mt-1">
                                                        {errors.salutation}
                                                    </span>
                                                </div>
                                            </>}
                                        </div>
                                    </div>

                                    <div className="row mt-4 text-20-24">
                                        <div className="col-md-3 col-4 dark-grey-color d-flex flex-column justify-content-center">
                                            <label>{resources.FirstName}<span className="red">*</span></label>
                                        </div>
                                        <div className="col-8 col-md-9">
                                            <input
                                                type="text"
                                                name="firstname"
                                                className="form-control"
                                                value={user.firstname}
                                                onChange={(e) => onInputChange(e)}
                                                required
                                            />
                                            {errors.firstname && <>
                                                <div className="mt-2 d-flex">
                                                    <img src={imgExclamation} alt="!" />
                                                    <span className="red text-16-18 ms-2 mt-1">
                                                        {errors.firstname}
                                                    </span>
                                                </div>
                                            </>}
                                        </div>
                                    </div>

                                    <div className="row mt-4 text-20-24 ">
                                        <div className="col-md-3 col-4 dark-grey-color d-flex flex-column justify-content-center">
                                            <label>{resources.Name}<span className="red">*</span></label>
                                        </div>
                                        <div className="col-8 col-md-9">
                                            <input
                                                type="text"
                                                name="lastname"
                                                className="form-control"
                                                value={user.lastname}
                                                onChange={(e) => onInputChange(e)}
                                                required
                                            />
                                            {errors.lastname && <>
                                                <div className="mt-2 d-flex">
                                                    <img src={imgExclamation} alt="!" />
                                                    <span className="red text-16-18 ms-2 mt-1">
                                                        {errors.lastname}
                                                    </span>
                                                </div>
                                            </>}
                                        </div>
                                    </div>

                                    <div className="row mt-4 text-20-24 ">
                                        <div className="col-md-3 col-4 dark-grey-color d-flex flex-column justify-content-center">
                                            <label>{resources.Company}</label>
                                        </div>
                                        <div className="col-8 col-md-9">
                                            <input
                                                type="text"
                                                name="company"
                                                className="form-control"
                                                value={user.company}
                                                onChange={(e) => onInputChange(e)}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mt-4 text-20-24 ">
                                        <div className="col-md-3 col-4 dark-grey-color d-flex flex-column justify-content-center">
                                            <label>{resources.Street}{!isMember && <span className="red">*</span>}</label>
                                        </div>
                                        <div className="col-8 col-md-9">
                                            <input
                                                type="text"
                                                name="street"
                                                className="form-control"
                                                value={user.street}
                                                onChange={(e) => onInputChange(e)}
                                                required
                                            />
                                            {errors.street && <>
                                                <div className="mt-2 d-flex">
                                                    <img src={imgExclamation} alt="!" />
                                                    <span className="red text-16-18 ms-2 mt-1">
                                                        {errors.street}
                                                    </span>
                                                </div>
                                            </>}
                                        </div>
                                    </div>

                                    <div className="row mt-4 text-20-24 ">
                                        <div className="col-md-3 col-4 dark-grey-color d-flex flex-column justify-content-center">
                                            <label>{resources.Post}{!isMember && <span className="red">*</span>}</label>
                                        </div>
                                        <div className="col-md-9 col-4">
                                            <input
                                                type="text"
                                                name="place"
                                                className="form-control"
                                                value={user.place}
                                                onChange={(e) => onInputChange(e)}
                                                required
                                            />
                                            {errors.place && <>
                                                <div className="mt-2 d-flex">
                                                    <img src={imgExclamation} alt="!" />
                                                    <span className="red text-16-18 ms-2 mt-1">
                                                        {errors.place}
                                                    </span>
                                                </div>
                                            </>}
                                        </div>
                                    </div>

                                    <div className="row mt-4 text-20-24 ">
                                        <div className="col-md-3 col-4 dark-grey-color d-flex flex-column justify-content-center">
                                            <label>{resources.City}{!isMember && <span className="red">*</span>}</label>
                                        </div>
                                        <div className="col-md-9 col-4">
                                            <input
                                                type="text"
                                                name="city"
                                                className="form-control"
                                                value={user.city}
                                                onChange={(e) => onInputChange(e)}
                                                required
                                            />
                                            {errors.city && <>
                                                <div className="mt-2 d-flex">
                                                    <img src={imgExclamation} alt="!" />
                                                    <span className="red text-16-18 ms-2 mt-1">
                                                        {errors.city}
                                                    </span>
                                                </div>
                                            </>}
                                        </div>
                                    </div>

                                    <div className="row mt-4 text-20-24 ">
                                        <div className="col-md-3 col-4 dark-grey-color d-flex flex-column justify-content-center">
                                            <label>{resources?.Country}{!isMember && <span className="red">*</span>}</label>
                                        </div>
                                        <div className="col-md-9 col-8 ">
                                            <select
                                                className="form-control"
                                                aria-label="Land"
                                                name="country"
                                                value={user.country}
                                                onChange={(e) => onInputChange(e)}>
                                                {countries.map((c, index) => (
                                                    <option value={c.id} key={index}>
                                                        {c.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.country && <>
                                                <div className="mt-2 d-flex">
                                                    <img src={imgExclamation} alt="!" />
                                                    <span className="red text-16-18 ms-2 mt-1">
                                                        {errors.country}
                                                    </span>
                                                </div>
                                            </>}
                                        </div>
                                    </div>

                                    <div className="row mt-4 text-20-24 ">
                                        <div className="col-md-3 col-4 dark-grey-color d-flex flex-column justify-content-center">
                                            <label>{resources?.ShippingEmail}<span className="red">*</span></label>
                                        </div>
                                        <div className="col-md-9 col-8 ">
                                            <input
                                                type="text"
                                                name="email"
                                                className="form-control"
                                                value={user.email}
                                                onChange={(e) => onInputChange(e)}
                                                required
                                            />
                                            {errors.email && <>
                                                <div className="mt-2 d-flex">
                                                    <img src={imgExclamation} alt="!" />
                                                    <span className="red text-16-18 ms-2 mt-1">
                                                        {errors.email}
                                                    </span>
                                                </div>
                                            </>}
                                        </div>
                                    </div>

                                    <div className="row mt-4 text-20-24 ">
                                        <div className="col-md-3 col-4 dark-grey-color d-flex flex-column justify-content-center">
                                            <label>{resources?.ShippingEmailConfirmation}<span className="red">*</span></label>
                                        </div>
                                        <div className="col-md-9 col-8">
                                            <input
                                                type="text"
                                                name="confirmemail"
                                                className="form-control"
                                                value={user.confirmemail}
                                                onChange={(e) => onInputChange(e)}
                                                required
                                            />
                                            {errors.confirmemail && !errors.emailmismatch && <>
                                                <div className="mt-2 d-flex">
                                                    <img src={imgExclamation} alt="!" />
                                                    <span className="red text-16-18 ms-2 mt-1">
                                                        {errors.confirmemail}
                                                    </span>
                                                </div>
                                            </>}
                                            {errors.emailmismatch && <>
                                                <div className="mt-2 d-flex">
                                                    <img src={imgExclamation} alt="!" />
                                                    <span className="red text-16-18 ms-2 mt-1">
                                                        {errors.emailmismatch}
                                                    </span>
                                                </div>
                                            </>}
                                        </div>
                                    </div>

                                    <div className="row mt-4 text-20-24 ">
                                        <div className="col-md-12 mb-3">
                                            <div className="form-check mb-4 d-flex align-items-center">
                                                <input
                                                    className="form-check-input me-3 custom-checkbox"
                                                    type="checkbox"
                                                    checked={acceptTermsAndConditions}
                                                    onChange={(e) => setAcceptTermsAndConditions(e.target.checked)}
                                                    id="termsCheckbox"
                                                />
                                                <label htmlFor="termsCheckbox" className="form-check-label text-16-18 dark-grey-color"
                                                    dangerouslySetInnerHTML={{ __html: resources.TermsAndConditionsConfirm }}>
                                                </label>
                                            </div>
                                            {errors.acceptTermsAndConditions && <>
                                                <div className="mt-2 d-flex">
                                                    <img src={imgExclamation} alt="!" />
                                                    <span className="red text-16-18 ms-2 mt-1">
                                                        {errors.acceptTermsAndConditions}
                                                    </span>
                                                </div>
                                            </>}
                                        </div>
                                    </div>

                                    <div className="row mt-4 mb-4">
                                        <div className="col-6">
                                            <button className="btn transperant-grey-button" onClick={() => navigate(-1)}>
                                                {resources?._Back}
                                            </button>
                                        </div>
                                        <div className="col-6 text-end">
                                            <button
                                                className="btn grey-button"
                                                onClick={() => onSubmit()}
                                            >
                                                {resources?.Continue}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </main>
                            <Footer />
                        </>
                    )}
            </div>
        </>
    );
};

export default Step20_Shipping;